"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fmko_ts_common_1 = require("fmko-ts-common");
/**
 * @deprecated use {@link UngroupedDropdownWidget} or {@link GroupedDropdownWidget} instead.
 */
class BaseListBox extends fmko_ts_common_1.Widget {
    constructor(element) {
        super();
        this.options = [];
        this.handlerManager = new fmko_ts_common_1.HandlerManager();
        if (element && element.nodeName !== "SELECT") {
            throw new Error("When initialized with an existing element, it must be a select element (got '"
                + element.nodeName.toLowerCase() + "')");
        }
        this.element = element || document.createElement("select");
    }
    getSelect() {
        return this.element;
    }
    getOptions() {
        return this.options;
    }
    setValue(value, fireEvents = false) {
        const oldValue = this.getValue();
        let optionIndex = this.options?.findIndex(option => value === option
            || (value && option)
                && this.model.isEqual(value, option)) ?? -1;
        if (optionIndex > -1) {
            this.element.selectedIndex = this.itemOffset + optionIndex;
        }
        if (optionIndex === -1) {
            if (!this.setUnknownValue(value)) {
                return;
            }
        }
        if (fireEvents) {
            fmko_ts_common_1.ValueChangeEvent.fireIfNotEqual(this, oldValue, value);
        }
    }
    getValue() {
        const selectedIndex = this.element.selectedIndex - this.itemOffset;
        if (selectedIndex >= 0 && selectedIndex < this.options.length) {
            return this.options[selectedIndex];
        }
        else {
            return null;
        }
    }
    addValueChangeHandler(handler) {
        if (!this.valueChangeHandlerInitialized) {
            this.valueChangeHandlerInitialized = true;
            this.element.addEventListener("change", () => {
                this.fireEvent(new fmko_ts_common_1.ValueChangeEvent(this.getValue()));
            });
        }
        return this.handlerManager.addHandler(handler);
    }
    fireEvent(event) {
        this.handlerManager.fireEvent(event);
    }
    /* from Focusable interface. */
    getTabIndex() {
        return this.element.tabIndex;
    }
    /* from Focusable interface. */
    setTabIndex(tabIndex) {
        this.element.tabIndex = tabIndex;
    }
    /* from Focusable interface. */
    setAccessKey(key) {
        this.element.accessKey = key;
    }
    /* from Focusable interface. */
    setFocus(focused) {
        if (focused) {
            this.element.focus();
        }
        else {
            this.element.blur();
        }
    }
    setEnabled(enabled) {
        this.element.disabled = !enabled;
        this.element.classList.toggle("disabled", !enabled);
    }
    setUnknownValue(value) {
        if (!value) {
            this.element.selectedIndex = 0;
        }
        else {
            this.options.push(value);
            const option = document.createElement("option");
            option.text = this.model.formatItem(value);
            const index = this.itemOffset + this.options.length - 1;
            this.element.add(option, index);
            this.element.selectedIndex = index;
        }
        return true;
    }
}
exports.default = BaseListBox;
//# sourceMappingURL=BaseListBox.js.map